import { registerPermissionRequest, getSubscriptionId, removeSubscriptionId } from './storage';
import { getPushNotificationsClientInstance } from './getPushNotificationsClientInstance';

/**
 * Unsubscribe from push notifications.
 *
 * @param {boolean} block - Whether to block asking for push notifications for a long time
 *
 * @returns {Promise} - A promise that resolves when the operation has finished
 */
export async function unsubscribeFromNotifications(block) {
    const subscription = await getPushNotificationsClientInstance().getSubscription(),
        subscriptionId = getSubscriptionId();

    if (subscriptionId) {
        app.api.users.unregisterDevice(subscriptionId);
        removeSubscriptionId();
    }

    if (subscription) {
        subscription.unsubscribe();
    }

    if (block) {
        registerPermissionRequest();
    }
}
